import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from '@src/styled-components';
import { Button, Modal, Form, Icon, List, Divider } from 'antd';
import FormItem from 'antd/lib/form/FormItem';
import React from 'react';
import IExecutionComponent from '../interfaces/IExecutionComponent';
import I18n from '@src/i18n';
import _ from 'lodash';
const { confirm } = Modal;

export interface IGoToExecutionProps extends IExecutionComponent {
  description: string;
  repeat: boolean;
  options: any;
  isMultiple: boolean;
  required: boolean;
  minMultiple: number;
  onClick: (id: number, componentId: string, repeat: boolean) => void;
  onChange: Function;
  onDelete: Function;
  nextClickError: boolean;
}

interface IGoToExecutionState {
  valid: boolean
}
export default class GoToExecutionComponent extends React.Component<IGoToExecutionProps, IGoToExecutionState> {
  constructor(props: IGoToExecutionProps) {
    super(props);
    this.state = {
      valid: false
    }
    this.showDeleteConfirm = this.showDeleteConfirm.bind(this);
  }
  componentDidMount() {
    const { minMultiple, defaultValue, onChange } = this.props;
    let validChange: boolean;
    if (defaultValue) {
      validChange = defaultValue.length < minMultiple ? false : true;
      this.setState({ valid: validChange }, () => {
        onChange({
          id: this.props.id,
          validation: [validChange]
        })
      })
    }
  }
  componentDidUpdate(prevProps: any, prevState: any){
    if (JSON.stringify(prevProps.defaultValue) !== JSON.stringify(this.props.defaultValue)) {
    const { minMultiple, defaultValue, onChange } = this.props;
    let validChange: boolean;
    if (defaultValue) {
      validChange = defaultValue.length < minMultiple ? false : true;
      this.setState({ valid: validChange }, () => {
        onChange({
          id: this.props.id,
          validation: [validChange]
        })
      })
    }
  }
  }
  onClickGoto = async (index: number, repeat: boolean) => {
    await this.props.onClick(index, this.props.id, repeat);
  }
  hasDefVal(index: number) {
    return this.props.defaultValue && this.props.defaultValue[index]
  }
  checkValidation(index: number) {
    let iconChecked: JSX.Element[] = []
    if (this.hasDefVal(index)) {
      iconChecked.push(<div className='icon'><FontAwesomeIcon style={{ color: 'green' }} icon={'check-circle'} /></div>)
    } else {
      iconChecked.push(<div className='icon' />)
    }
    return iconChecked;
  }
  actionsRender(index: number) {
    const { id, sectionId } = this.props.options[this.props.repeat ? 0 : index]
    let actions: JSX.Element[] = []
    if (this.hasDefVal(index)) {
      actions.push(<div className='actions'>
        <Button onClick={() => this.onClickGoto(index, this.props.repeat)} type='link'>{I18n.l("common.edit")}</Button>
        <Divider type="vertical" />
        <Button type='link' onClick={() => this.showDeleteConfirm(sectionId, index)} style={{ color: 'red' }} >{I18n.l("common.delete")}</Button></div>)
    } else {
      actions.push(<div className='actions'><Icon type='right' style={{ fontSize: '10px' }} /></div>)
    }
    return actions;
  }
  showDeleteConfirm(sectionId: string, index: number) {
    const _this = this;

    confirm({
      title: I18n.l("goTo.modal.confirmDelete.title"),
      okText: I18n.l("common.delete"),
      cancelText: I18n.l("common.cancel"),
      onOk() {
        _this.props.onDelete(sectionId, _this.props.id, index, _this.props.id)
      },
    });
  }
  renderList(item: any, index: number) {
    const { defaultValue } = this.props;
    if (!this.props.repeat) {      
      return (
        <List.Item key={`goto_${index}`} className={this.hasDefVal(index) ? '' : 'pointer'} onClick={() => this.hasDefVal(index) ? {} : this.onClickGoto(index, false)}>
          {this.checkValidation(index)}
          <div className='descItem'>{item.label}</div>
          {this.actionsRender(index)}
        </List.Item>
      )
    } else {
      if (defaultValue && defaultValue.length > 0 && index === 0) {
        return defaultValue.map((value : any,indexValue : number) => {
          return <List.Item key={`repeatGoto_${value}`}>
            <div className='icon'><FontAwesomeIcon style={{ color: 'green' }} icon={'check-circle'} /></div>
            <div className='descItem'>{`${item.label} ${indexValue > 0 ? ` (${indexValue})` : ''}`}</div>
            {this.actionsRender(indexValue)}
          </List.Item>
        })
      }
      return []
    }
  }
  renderRepeat() {
    const {defaultValue} = this.props;
    let index = defaultValue ? defaultValue.length : 0;
    return <Button
      onClick={() => this.onClickGoto(index,this.props.repeat)}
      style={{ marginLeft: '-15px', fontWeight: 'bold' }}
      className="goepik-btn-border-main-withoutbold"
    >
      <Icon type="plus" /> {I18n.l("common.addNew")}
    </Button>
  }
  render() {
    return (
      <Wrapper>
        <Form>
          <FormItem>
            <List
              key={this.props.id}
              header={<p>{this.props.description}</p>}
              dataSource={this.props.options}
              renderItem={(item: any, i: number) => this.renderList(item, i)}
              footer={this.props.repeat ? this.renderRepeat() : false}
            />
          </FormItem>
        </Form>
        {this.props.nextClickError && !this.state.valid && <>
          {<p style={{ color: 'red' }} >{I18n.l("goTo.messageValidation").replace('qtd', this.props.minMultiple)}</p>}
        </>}
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  .ant-list-item{
    &.pointer{
      cursor: pointer;
    }
    .icon{
      width: 14px;
    }
    display: flex;
    justify-content: apace-between;
    .icon{
      width: 14px;
      margin:  0px 5px;
    }
    .descItem{
      width: 100%;
      aling-text: left;
    }
    .actions{
      display: flex;
      align-items: center;
    }
  }
`